let animationLength = 0.8;
export function registrationStepAnimation() {
  'ngInject';
  return {
    enter: function (element, done) {
      let actor = element[0];
      TweenLite.set(actor, {display: 'none', overflow: 'visible'});
      window.setTimeout(function () {
        TweenLite.fromTo(actor, animationLength, {x: '100%', clearProps: 'display'}, {
          x: '0%', onComplete: function () {
            done();
          }
        });
      }, (animationLength / 2) * 1000);
    },
    leave: function (element, done) {
      let actor = element[0],
        parent = element.parent(),
        timeLine = new TimelineLite({paused: true});
      timeLine.add(new TweenLite.to(parent, animationLength / 2, {opacity: 0}), 's');
      timeLine.add(new TweenLite.fromTo(actor, animationLength / 2, {
        opacity: 1,
      }, {
        opacity: 0
      }), 's');
      timeLine.eventCallback('onComplete', function () {
        done();
        TweenLite.to(parent, animationLength / 2, {opacity: 1, delay: animationLength / 3});
        TweenLite.set(actor, {clearProps: 'opacity'});
      });
      timeLine.play();
    }
  };
}




/** WEBPACK FOOTER **
 ** ./src/app/ecourse/registration/registration.animation.js
 **/